export default __webpack_public_path__ + "static/media/Blog2_3.1cfb41b5.jpg";